import { Wrapper } from './WidgetBase.styles';

import { WidgetProps } from '@/types';

type Props = {
  children: React.ReactNode;
} & WidgetProps;

export const WidgetBase: React.FC<Props> = ({
  id,
  special,
  title,
  subTitle,
  addon,
  children,
  position = '',
  headersize = 'small',
  hoverable = false,
  backgroundcolor,
  padding,
  onHeaderClick
}) => {
  return (
    <Wrapper
      id={id}
      hoverable={hoverable}
      headersize={headersize}
      special={special}
      headerClickable={!!onHeaderClick}
      backgroundcolor={backgroundcolor}
      $padding={padding}
      style={{ gridArea: position }}>
      {(title || addon) && (
        <>
          <div onClick={onHeaderClick}>
            <div>
              {title && <div>{title}</div>}
              {subTitle && <div className="subtitle">{subTitle}</div>}
            </div>
            {addon && <div>{addon}</div>}
          </div>
        </>
      )}
      <section>{children}</section>
    </Wrapper>
  );
};
